<app-filter-header title="Filtrar remesas" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-date-edit id="envio-filter-dataIniDGT" class="col-sm-3" i18n-label label="Fecha inicio" [(value)]="filter.fechaInicio" type="calendar"></app-form-date-edit>
    <app-form-date-edit id="envio-filter-dataFinDGT" class="col-sm-3" i18n-label label="Fecha fin" [(value)]="filter.fechaFin" type="calendar"></app-form-date-edit>

  </div>
</div>
